import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { ItemStatus } from '@shared/types';

const LABELS: Record<ItemStatus, string> = {
  drafting: 'Drafting',
  building: 'Building',
  'needs-review': 'Needs review',
  publishing: 'Publishing',
  published: 'Published',
  failed: 'Failed',
};

const COLORS: Record<ItemStatus, string> = {
  drafting: 'bg-slate-100 text-slate-700 border-slate-200',
  building: 'bg-blue-100 text-blue-700 border-blue-200',
  'needs-review': 'bg-amber-100 text-amber-800 border-amber-300',
  publishing: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  published: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  failed: 'bg-red-100 text-red-700 border-red-200',
};

export function StatusBadge({ status }: { status: ItemStatus }) {
  return (
    <Badge
      variant="outline"
      className={cn('font-medium', COLORS[status])}
    >
      {LABELS[status]}
    </Badge>
  );
}
